<template>
    <div class="container-fluid p-4">
        <div class="row ">
            <div class="col">
                <div class="header-wrapper">
                    <div class="nav">
                        <span class="prev" @click="changeMonth(-1)">
                            <i class="material-icons">
                            navigate_before
                            </i>
                        </span>
                        <span class="next" @click="changeMonth(1)">
                            <i class="material-icons">
                            navigate_next
                            </i>
                        </span>
                    </div>
                    <div class="main-info">
                        <h4>
                            {{ currentDateFormatted.month }} {{ currentDateFormatted.year }}
                        </h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" :style="setCalendarStyle">
            <div class="col mt-3">
                <div class="flex-container">
                    <div v-for="label in daysLabel" :key="label" class="flex-item-label">
                        {{ label }}
                    </div>
                </div>
                <div v-for="(row, idx1) in items" :key="row.dateId" class="flex-container">
                    <div v-for="(col, idx2) in row" :key="col.dateId" class="flex-item">
                        <scheduleDay
                            :dayItem="dayItems[idx1][idx2]"
                            :users="users"
                            />
                    </div>
                </div>
            </div>
            <div :class="setOverlayClass"></div>
        </div>
        <div class="row" v-if="isAdmin">
          <div class="col-4 mt-3" v-if="scheduleStatus == 'EDITABLE'">
            <input class="btn btn-success btn-sm mr-2 torre-btn" value="Zablokuj" type="button" @click="blockSchedule">
          </div>
          <div class="col-4 mt-3" v-if="scheduleStatus == 'BLOCKED'">
            <input class="btn btn-success btn-sm mr-2 torre-btn" value="Odblokuj" type="button" @click="unBlockSchedule">
          </div>
        </div>
        <div class="row">
            <div class="col-4 mt-3" v-if="stats.length > 0">
                <p>{{ statsHeaderInfo }}</p>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                Użytkownik
                            </th>
                            <th>
                                Godziny w miesiącu
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in stats" :key="item.user">
                            <td>
                                {{ item.user }}
                            </td>
                            <td>
                                {{ item.hours }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import un from 'underscore'
import schedulePattern from "./SchedulePattern"
import scheduleDay from "./ScheduleDay"
import restClient from "./ScheduleRestClient"
import userService from '@/service/userService'

export default {
    components: {
        scheduleDay
    },
    data: () => ({
        usersToRemove: ["twojnowski", "epieszczyk", "epieszczyk1"],
        users: [],
        stats: [],
        currentDate: moment().format("YYYY-MM"),
        daysLabel: schedulePattern.daysLabel,
        scheduleStatus: ""
    }),
    created() {
        this.initItems()
        this.initUsers()
        this.$eventHub.$on('dataChanged', this.reloadData)
    },
    destroyed() {
        this.$eventHub.$off('dataChanged')
    },
    watch: {
        currentDate() {
            this.initItems()
        }
    },
    computed: {
        isAdmin() {
            return userService.isAdmin();
        },
        currentDateFormatted() {
            const date = moment(this.currentDate)
            return {
                year: date.year(),
                month: schedulePattern.monthsLabel[date.month()]
            }
        },
        items() {
            return this.$store.getters.currentDayItems
        },
        dayItems() {
            return this.$store.getters.currentDayItems
        },
        statsHeaderInfo() {
            let from = this.fetchStatsParams.startDay
            let to = this.fetchStatsParams.endDay
            return `Czas liczony od dnia ${from} do ${to}`
        },
        fetchStatsParams() {
            return schedulePattern.fetchStatsParams(this.items)
        },
        isScheduleBlocked() {
            return "BLOCKED" === this.scheduleStatus
        },
        setOverlayClass() {
            if (this.isScheduleBlocked) {
                return "calendar-overlay"
            }
            return ""
        },
        setCalendarStyle() {
            if (this.isScheduleBlocked) {
                return "position: relative"
            }
            return ""
        }
    },
    methods: {
        unBlockSchedule(){
            const fetchDaysParams = schedulePattern.fetchDaysParams(this.items)
            restClient.unBlockDays(fetchDaysParams)
            .then(res => {
                this.reloadData()
            })
            .catch(err => {
                console.log(err)
            })
        },
        blockSchedule() {
            const fetchDaysParams = schedulePattern.fetchDaysParams(this.items)
            restClient.blockDays(fetchDaysParams)
            .then(res => {
                this.reloadData()
            })
            .catch(err => {
                console.log(err)
            })
        },
        reloadData() {
            this.initItems()
            this.initStats()
        },
        initStats() {
            restClient.fetchStats(this.fetchStatsParams)
            .then(res => {
                this.stats = res.data.stats
            })
            .catch(err => {
                console.log(err)
            })
        },
        initUsers() {
            restClient.getUsers()
            .then(res => {
                this.users = un.chain(res.data)
                .map(user => user.login)
                .filter(user => this.usersToRemove.indexOf(user) < 0)
                .value()
                .sort()
            })
        },
        initItems() {
            const items = schedulePattern.buildEmptyDayItems(moment(this.currentDate))
            this.$store.commit("initDayItems", items)
            this.fetchDays()
        },
        fetchDays() {
            const fetchDaysParams = schedulePattern.fetchDaysParams(this.items)
            restClient.fetchDays(fetchDaysParams)
            .then(res => {
                this.scheduleStatus = res.data.status
                this.mergeItems(res.data.days)
                this.initStats()
            })
            .catch(err => {
                console.log(err)
            })
        },
        mergeItems(itemsMap) {
            const keys = Object.keys(itemsMap)
            keys.forEach((key, _, __) => {
                var item = schedulePattern.findDayItemByDateId(this.items, key)
                if (item) {
                    item.entries = itemsMap[key].daysInfo
                    item.status = itemsMap[key].status
                    this.$store.commit('updateDayItem', item)
                }
            })
        },
        changeMonth(change) {
            var date = moment(this.currentDate)
            date = date.add(change, "month")
            this.currentDate = date.format("YYYY-MM")
        }
    }
}
</script>

<style lang="scss" scoped>
    $torre-green: #97b84d;

    .header-wrapper {
        position: relative;

        .main-info {
            margin: 0;
            padding: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-right: -50%;
            transform: translate(-50%, -50%)
        }
    }
    .nav span {
        background-color: $torre-green;
        border-color: $torre-green;
        height: 30px;
        width: 34px;
        &:hover {
            cursor: pointer;
            background-color: #72912c;
        }
        &:active {
            background-color: #72912c !important;
        }
        &:focus {
            background-color: #72912c !important;
        }
        i {
            margin-top: 3px;
        }
    }

    .prev {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        i {
            margin-left: 4px;
        }
    }

    .next {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        i {
            margin-left: 4px;
        }
    }

    .calendar-overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.0;
        z-index: 9;
        margin: 10px;
        background: #6b6666;
        border-radius: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/schedule/ScheduleView.vue